<template>
  <div class="userDiv flexCC colorC" :class="userInfo.phoneNumber && 'active'">
    <img class="cur" src="@/assets/img/userImg.png" />
    <i class="el-icon-arrow-down"></i>
    <ul v-show="userInfo.phoneNumber" class="tran">
      <div class="flexCC">
        <img src="@/assets/img/userImg.png" />
        <p class="flexCSC font18 fwNo">
          {{ userInfo.userId }}
          <span class="font16">
            {{
              userInfo.phoneNumber &&
              userInfo.phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")
            }}
          </span>
        </p>
      </div>
      <li
        class="flexCB cur"
        v-for="(item, index) in userList"
        :key="'userList' + index"
        @click="getUserUrl(item)"
      >
        <h2 class="font16 fwNo tran" :class="index == 3 && 'active'">
          <i :class="item.icon"></i>
          {{ item.name }}
        </h2>
        <i class="el-icon-arrow-right tran"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 用户信息
      userInfo: {},
      // 用户操作列表
      userList: [
        {
          name: "用户中心",
          icon: "iconfont icon-yonghuzhongxin2",
          url: "/user/info",
        },
        {
          name: "充值",
          icon: "iconfont icon-baobiaoguanli",
          url: "/user/recharge",
        },
        { name: "系统管理", icon: "iconfont icon-xitong", url: "/user/table" },
        {
          name: "功能主页面",
          icon: "iconfont icon-gongnengzhuyemian",
          url: "/aiMain",
        },
        { name: "退出登录", icon: "iconfont icon-tuichu", url: "loginOut" },
      ],
    };
  },
  methods: {
    // 用户操作列表
    getUserUrl(obj) {
      if (!obj || !obj.url) return;

      // 退出登录
      if (obj.url == "loginOut") {
        this.userInfo = null;
        localStorage.removeItem("userInfo");

        this.$router.push("/");
      } else {
        this.$router.push(obj.url);
      }
    },
  },
  mounted() {
    const userInfoJSON = localStorage.getItem("userInfo");
    if (userInfoJSON) {
      this.userInfo = JSON.parse(userInfoJSON);
    } else {
      this.userInfo = null;
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped>
.userDiv {
  width: 5rem;
  height: 5rem;
  position: relative;

  &:hover > ul {
    transform: scaleY(1);
  }

  > img {
    width: 3.8rem;
    height: auto;
    overflow: hidden;
    margin: 0 0.5rem 0 0;
  }

  > ul {
    width: 27rem;
    overflow: hidden;
    padding: 3rem 2rem 0 2rem;
    letter-spacing: 0;
    background-color: #0d111c;
    border: 0.1rem solid #333;
    border-radius: 1rem;
    transform: scaleY(0);
    transform-origin: top;
    position: absolute;
    top: 5rem;
    right: 0;
    z-index: 100;

    > div {
      overflow: hidden;
      padding: 0 0 3rem 0;

      > img {
        width: 3.8rem;
        height: auto;
        overflow: hidden;
        margin: 0 1rem 0 0;
      }

      > p {
        flex: 1;
        overflow: hidden;

        > span {
          color: #929ca8;
        }
      }
    }

    > li {
      height: 6rem;
      overflow: hidden;
      border-top: 0.1rem solid #333;

      &:hover > h2,
      &:hover > i {
        color: #fff;
      }

      > h2 {
        overflow: hidden;

        &.active {
          color: #1eeef0;
        }

        > i {
          font-size: 2rem;
          margin: 0 1rem 0 0;
        }
      }
    }
  }
}
</style>